exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th.sorted.asc .sorting-indicator:before{\r\n    content: \"\\F140\" !important;\r\n}\r\nth.sorted.desc .sorting-indicator:before{\r\n    content: \"\\F142\" !important;\r\n}", ""]);

// exports
